import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Avatar
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { IMAGE_URL } from "src/network/endpoints";

const BusinessRefundDetailsDialog = ({ open, onClose, orderData, onRefund }) => {
  const perUser = orderData?.refundSummary?.perUser || [];

  const getUserDisplay = (user) => {
    if (!user) return { name: "user", avatar: "" };
    const name = user.fullName || user.userName || "user";
    const avatar = user.image?.profilePic || "";
    return { name, avatar };
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ zIndex: 10003 }}
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
        <Typography variant="h6" sx={{ textTransform: "lowercase", fontWeight: 700, color: "#6d28d9" }}>
          refund details
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ textTransform: "lowercase", fontWeight: 600 }}>name</TableCell>
              <TableCell sx={{ textTransform: "lowercase", fontWeight: 600 }}>paid</TableCell>
              <TableCell sx={{ textTransform: "lowercase", fontWeight: 600 }}>refund amt</TableCell>
              <TableCell sx={{ textTransform: "lowercase", fontWeight: 600 }}>refund status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {perUser.map((u, idx) => {
              const info = getUserDisplay(u.userId);
              const paid = u.amountPaid ?? 0;
              const refunded = u.totalRefunded ?? 0;
              const status = refunded > 0 ? "payment completed" : orderData?.paymentStatus || "pending";
              return (
                <TableRow key={idx}>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Avatar src={`${IMAGE_URL}${info.avatar || ""}`} sx={{ width: 24, height: 24 }} />
                      <Typography variant="body2" sx={{ textTransform: "lowercase" }}>{info.name}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">${paid}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">${refunded}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ textTransform: "lowercase" }}>{status}</Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>

      <DialogActions sx={{ p: 2, justifyContent: "center" }}>
        <Button
          onClick={() => {
            if (onRefund) onRefund();
            onClose();
          }}
          variant="contained"
          color="primary"
          sx={{ textTransform: "lowercase", minWidth: 120 }}
        >
          refund
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BusinessRefundDetailsDialog;


